/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import React from 'react';
import styled, { css } from 'styled-components';
import { INDENT, View, VIEW_CONTENT_MOD } from '@veeam/components';

const Root = styled(View)`
    position: relative;
    flex: 1;
    overflow: auto;
`;

const Inner = styled(View)<{ width: string; fullWidth: boolean; }>`
    ${({ width, fullWidth }) => !fullWidth && width !== '100%' && css`
        max-width: ${width};
    `}
`;

export interface PageDialogBodyProps {
    children?: React.ReactElement | null | React.ReactText;
    fullWidthContent?: boolean;
    widthContent: string;
    bodyIndentTop?: INDENT;
    bodyIndentRight?: INDENT;
    bodyIndentBottom?: INDENT;
    bodyIndentLeft?: INDENT;
}

export const PageDialogBody = (
    {
        children,
        fullWidthContent = false,
        widthContent,
        bodyIndentTop = INDENT.s,
        bodyIndentRight = INDENT.m,
        bodyIndentBottom = INDENT.m,
        bodyIndentLeft = INDENT.m,
        ...rest
    }: PageDialogBodyProps
) => (
    <Root
        contentMod={VIEW_CONTENT_MOD.fill}
        clipped
        indentTop={bodyIndentTop}
        indentRight={bodyIndentRight}
        indentBottom={bodyIndentBottom}
        indentLeft={bodyIndentLeft}
        data-tid={rest['data-selector-id'] || 'pagedialog-dialogbody'}
    >
        <Inner fullWidth={fullWidthContent} width={widthContent}>
            {children}
        </Inner>
    </Root>
);

PageDialogBody.displayName = 'PageDialogBody';
